export const TranslocScope = {
  AUDIT: 'audit',
  CERTIFICATE: 'certificate',
  ACTIONS: 'actions',
  CONTRACTS: 'contracts',
  EXTERNAL_APPS: 'apps',
  FINANCIAL: 'invoices',
  FINDINGS: 'findings',
  NOTIFICATIONS: 'notifications',
  OVERVIEW: 'overview',
  SCHEDULES: 'schedules',
  SETTINGS: 'settings',
  FEATURE_ANNOUNCEMENTS: 'whatsNew',
};
